// src/features/tasks/services/taskTracking.js
import { apiClient } from '../../../services/api/client';

export const taskTrackingAPI = {
  // Task-specific tracking
  getTaskTrackingHistory: (taskId, params = {}) => 
    apiClient.get(`/api/v1/task-management/tracking/tasks/${taskId}`, { params }),
  
  getTaskActivitySummary: (taskId) => 
    apiClient.get(`/api/v1/task-management/tracking/tasks/${taskId}/summary`),
  
  getTaskRecurrenceHistory: (taskId, params = {}) =>
    apiClient.get(`/api/v1/task-management/tracking/tasks/${taskId}/recurrence-history`, { params }),
  
  // Department tracking
  getRecentDepartmentActivity: (params = {}) => 
    apiClient.get('/api/v1/task-management/tracking/department/recent', { params }),
  
  // Staff tracking
  getStaffMemberActivity: (staffMemberId, params = {}) => 
    apiClient.get(`/api/v1/task-management/tracking/staff/${staffMemberId}`, { params }),
  
  getMyActivity: (params = {}) => 
    apiClient.get('/api/v1/task-management/tracking/staff/me', { params }),
  
  // Statistics
  getTrackingStatistics: (params = {}) => 
    apiClient.get('/api/v1/task-management/tracking/statistics', { params }),
};